/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Session_Not_FoundInputs */

const en_ui_session_not_found = /** @type {(inputs: Ui_Session_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session not found.`)
};

const de_ui_session_not_found = /** @type {(inputs: Ui_Session_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheit nicht gefunden.`)
};

/**
* | output |
* | --- |
* | "Session not found." |
*
* @param {Ui_Session_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_session_not_found = /** @type {((inputs?: Ui_Session_Not_FoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Session_Not_FoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_session_not_found(inputs)
	return de_ui_session_not_found(inputs)
});